import { isActivitiesFeatureEnabled } from 'reactApp/appHelpers/featuresHelpers';
import { toggleActionPanel } from 'reactApp/modules/actionpanel/actionpanel.module';
import { dispatchNewSearchRadar } from 'reactApp/modules/dwh/dwh.module';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { store as reduxStore } from 'reactApp/store';
import { FilesFoldersLogViewer } from 'reactApp/ui/FilesFoldersLogViewer/FilesFolderLogViewer';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

import { getSelectedItems } from './helpers/getSelectedItems';

export const viewHistory = (contextMenu?: boolean): void => {
    const state = reduxStore.getState();
    const selectedItem = getSelectedItems(state)[0];
    const currentStorage = getCurrentStorage(state);
    if (currentStorage === EStorageType.search) {
        const dwhData = {
            eventCategory: contextMenu ? ECategoryGa.context_search : ECategoryGa.toolbar_search,
            action: 'open-history',
        };

        reduxStore.dispatch(
            dispatchNewSearchRadar({
                dwhData,
                items: [
                    {
                        file_name: 'nameWithoutExt' in selectedItem && selectedItem.nameWithoutExt,
                        file_id: selectedItem.id,
                        pos: 'pos' in selectedItem && selectedItem.pos,
                        type: selectedItem.kind,
                    },
                ],
            })
        );
    }

    if (isActivitiesFeatureEnabled) {
        reduxStore.dispatch(toggleActionPanel({ open: true, component: FilesFoldersLogViewer }));
    } else {
        openPopupHelper({ popupName: popupNames.FILE_HISTORY, data: { itemId: selectedItem?.id } });
    }
};
